import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CoPresentOutlinedIcon from "@mui/icons-material/CoPresentOutlined";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import type { SvgIconComponent } from "@mui/icons-material";

/** Unique sidebar heading icon per workflow group id (collapsed rail + section parent). */
export const WORKSPACE_NAV_GROUP_ICONS: Record<string, SvgIconComponent> = {
  dashboard: HomeOutlinedIcon,
  work: InboxOutlinedIcon,
  people: GroupsIcon,
  "time-attendance": FactCheckIcon,
  payroll: PaymentsOutlinedIcon,
  expenses: FlightTakeoffOutlinedIcon,
  talent: PsychologyOutlinedIcon,
  portals: CoPresentOutlinedIcon,
  reports: AssessmentOutlinedIcon,
  setup: SettingsOutlinedIcon,
  administration: AdminPanelSettingsOutlinedIcon,
  operations: WorkOutlineIcon,
};

export function resolveWorkspaceNavGroupIcon(
  groupId: string,
  fallback?: SvgIconComponent,
): SvgIconComponent {
  return WORKSPACE_NAV_GROUP_ICONS[groupId] ?? fallback ?? HomeOutlinedIcon;
}
